/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// @mui material components
import { Box } from "@mui/material";
import Card from "@mui/material/Card";

// components
import SoftBox from "components/SoftBox";
import SoftBadge from "components/SoftBadge";
import ActionCell from "./components/ActionCell";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { ACTION_TYPE_ENUM } from "enums/action-type";

// table
import DataTable from "./DataTable";

// service
import { BalanceSheetService } from "services/balanceSheetService";

const genColorAction = (value) => {
  switch (value) {
    case ACTION_TYPE_ENUM.NOT_RESPONSE:
      return "error";
    case ACTION_TYPE_ENUM.RESPONSE:
      return "success";
    default:
      return "info";
  }
};

const renderBadge = (content, color) => {
  return (
    <SoftBadge
      variant="contained"
      color={color}
      size="sm"
      badgeContent={content}
      circular
      container
    />
  );
};

const renderData = (items, setDataTable) => {
  return items.map((item, index) => ({
    id: item._id,
    name: [
      item.name,
      {
        image: item?.logo || "/upload.png",
      },
    ],
    members: item.members,
    // address: item.address,
    taxCode: item.taxCode,
    phone: item.phone,
    email: item.email,
    accountNumber: item.accountNumber,
    industries: item.industries?.join(", ") || "Trống",
    subscriptions: renderBadge(item.subscriptions, "warning"),
    actionType: renderBadge(item.actionType, genColorAction(item.actionType)),
    action: <ActionCell item={item} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    {
      Header: "Tên",
      accessor: "name",
      width: "15%",
      sorted: true,
      Cell: ({ value: [name, data] }) => (
        <Box display="flex" gap={1} alignItems="center">
          <Box width={50} height={50}>
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 12 }}
              src={data.image}
              alt={name}
            />
          </Box>
          <Box>{name}</Box>
        </Box>
      ),
    },
    {
      Header: "Mã số thuế",
      accessor: "taxCode",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Số điện thoại",
      accessor: "phone",
    },
    {
      Header: "Số tài khoản",
      accessor: "accountNumber",
    },
    {
      Header: "Nhân viên",
      accessor: "members",
    },
    {
      Header: "Ngành nghề",
      accessor: "industries",
    },
    {
      Header: "Gói đăng ký",
      accessor: "subscriptions",
    },
    {
      Header: "Loại hoạt động",
      accessor: "actionType",
    },
    // {
    //   Header: "Địa chỉ",
    //   accessor: "address",
    // },
    {
      Header: "Actions",
      accessor: "action",
      align: "right",
    },
  ],
  rows: [],
};

function BalanceSheet() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc", searchBy: "" });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 25,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const queryParams = {
        ...query,
        limit: paginationData.size,
        page: paginationData.page,
      };
      const {
        data: { items, paginate },
      } = await BalanceSheetService.getAll(queryParams);
      setPaginationData((prev) => ({ ...prev, count: paginate.count, size: paginate.size }));
      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error({ error });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default BalanceSheet;
